import { useMutation } from 'react-query';
import { ITrackUnTrackPayload } from 'components/Dashboards/Project/Components/VersionCompare/queries/tableDataMutation';
import { network } from 'services/network';

const trackUnTrackItems = (params) => {
    return network
        .post('api/bo/trackUntrackItems', params)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw error;
        });
};

export const useMutationTrackUnTrackItems = () => {
    return useMutation<string, QueryError, ITrackUnTrackPayload>((params) => trackUnTrackItems(params));
};
